import { Table, TableBody, TableContainer, TableHead } from '@material-ui/core';
import PropTypes from 'prop-types';

import { Loader } from 'src/components/Loader';

import { HeaderRow } from './components/HeaderRow';
import { ProjectFolderTableRows } from './components/ProjectFolderTableRows';
import { ProjectTableRows } from './components/ProjectTableRows';
import styles from './styles.module.css';

export const TableProjects = ({
  className,
  projects,
  projectFolders,
  loading,
  hideActions,
  hideSort,
  nameOnly,
  sortOrder,
  sortField,
  onSortChange,
  onProjectAction,
  onProjectFolderAction,
}) => {
  return (
    <TableContainer className={className}>
      <Table
        className={styles.table}
        stickyHeader
      >
        <TableHead>
          <HeaderRow
            sortField={sortField}
            sortOrder={sortOrder}
            onSortChange={onSortChange}
            hideActions={hideActions}
            hideSort={hideSort}
            nameOnly={nameOnly}
          />
        </TableHead>

        {!loading && (
          <TableBody>
            {projectFolders?.length > 0 && (
              <ProjectFolderTableRows
                projectFolders={projectFolders}
                onProjectFolderAction={onProjectFolderAction}
                hideActions={hideActions || !onProjectFolderAction}
              />
            )}

            <ProjectTableRows
              projects={projects}
              onProjectAction={onProjectAction}
              hideActions={hideActions}
              nameOnly={nameOnly}
            />
          </TableBody>
        )}
      </Table>

      {loading && <Loader className={styles.loader} />}
    </TableContainer>
  );
};

TableProjects.propTypes = {
  className: PropTypes.string,
  projects: PropTypes.arrayOf(PropTypes.shape({})),
  projectFolders: PropTypes.arrayOf(PropTypes.shape({})),
  loading: PropTypes.bool,
  hideActions: PropTypes.bool,
  hideSort: PropTypes.bool,
  // Only the project name, for lists that know nothing more about the projects.
  nameOnly: PropTypes.bool,
  sortOrder: PropTypes.string,
  sortField: PropTypes.string,
  onSortChange: PropTypes.func,
  onProjectAction: PropTypes.func.isRequired,
  onProjectFolderAction: PropTypes.func,
};

TableProjects.defaultProps = {
  className: null,
  projects: [],
  projectFolders: [],
  loading: false,
  hideActions: false,
  hideSort: false,
  nameOnly: false,
  sortOrder: null,
  sortField: null,
  onSortChange: null,
  onProjectFolderAction: null,
};
